import '../styles/NavigationLink.scss';
import { pluck } from '../utils';
import Link from './Link';

const NavigationLink = $ => {
    const props = pluck('page')({
        ...$,
        className: 'navigationLink' 
            + ($.name === $.page 
                ? ' active' 
                : ''
            )
    })

    return <Link {...props}/>
}

export default NavigationLink;